(() => {
  const DEFAULT_AUTOPLAY_DELAY = 3500;

  const parseDelay = (el) => {
    const value = parseInt(el.dataset.autoplayDelay || '', 10);
    return Number.isFinite(value) && value > 0 ? value : DEFAULT_AUTOPLAY_DELAY;
  };

  const bindFocusPauseHandlers = (slider, swiper) => {
    if (slider.dataset.autoplayFocusBound === 'true') return;
    slider.dataset.autoplayFocusBound = 'true';

    slider.addEventListener('focusin', () => swiper.autoplay?.stop());
    slider.addEventListener('focusout', (event) => {
      const nextTarget = event.relatedTarget;
      if (!nextTarget || !slider.contains(nextTarget)) swiper.autoplay?.start();
    });
  };

  const buildAutoplayConfig = (slider) => {
    const slides = slider.querySelectorAll('.swiper-slide');
    const autoplayDisabled = slider.dataset.autoplay === 'false';
    if (slides.length <= 1 || autoplayDisabled) return false;

    return {
      delay: parseDelay(slider),
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    };
  };

  const initGridIconsSwiper = (slider) => {
    const paginationEl = slider.querySelector('.grid-icons__progress');
    const autoplay = buildAutoplayConfig(slider);

    const baseConfig = {
      slidesPerView: 1.8,
      spaceBetween: 24,
      freeMode: true,
      mousewheel: { forceToAxis: true },
      rewind: true,
      breakpoints: {
        990: {
          slidesPerView: 'auto',
          spaceBetween: 72,
        },
      },
    };

    if (paginationEl) {
      baseConfig.pagination = {
        el: paginationEl,
        type: 'progressbar',
      };
    }

    if (autoplay) baseConfig.autoplay = autoplay;

    if (slider.swiper) {
      if (paginationEl && slider.swiper.params.pagination) {
        slider.swiper.params.pagination.el = paginationEl;
        slider.swiper.pagination?.render?.();
        slider.swiper.pagination?.update?.();
      }

      slider.swiper.params.autoplay = autoplay || false;
      slider.swiper.params.rewind = baseConfig.rewind;
      slider.swiper.params.freeMode = baseConfig.freeMode;
      slider.swiper.params.mousewheel = baseConfig.mousewheel;
      slider.swiper.params.breakpoints = baseConfig.breakpoints;
      slider.swiper.params.slidesPerView = baseConfig.slidesPerView;
      slider.swiper.params.spaceBetween = baseConfig.spaceBetween;

      if (autoplay && slider.swiper.autoplay) slider.swiper.autoplay.start();
      else if (!autoplay && slider.swiper.autoplay) slider.swiper.autoplay.stop();

      slider.swiper.update();
      bindFocusPauseHandlers(slider, slider.swiper);
      return slider.swiper;
    }

    const swiperInstance = new Swiper(slider, baseConfig);

    if (autoplay && swiperInstance.autoplay && !swiperInstance.autoplay.running) {
      swiperInstance.autoplay.start();
    }

    bindFocusPauseHandlers(slider, swiperInstance);

    return swiperInstance;
  };

  const initAllGridIconSwipers = (root = document) => {
    const sliders = root.querySelectorAll('.grid-icons-swiper');
    sliders.forEach((slider) => initGridIconsSwiper(slider));
  };

  const initOnSectionEvent = (event) => {
    const sectionId = event.detail?.sectionId;
    if (!sectionId) return;
    const section = document.getElementById(`shopify-section-${sectionId}`);
    if (section) initAllGridIconSwipers(section);
  };

  document.addEventListener('DOMContentLoaded', () => {
    initAllGridIconSwipers();

    if (window.Shopify && window.Shopify.designMode) {
      ['load', 'select', 'reorder'].forEach((name) =>
        document.addEventListener(`shopify:section:${name}`, initOnSectionEvent)
      );
    }
  });
})();
